import { render } from "./purchases.vue?vue&type=template&id=21a50deb&scoped=true&ts=true"
import script from "./purchases.vue?vue&type=script&lang=ts"
export * from "./purchases.vue?vue&type=script&lang=ts"

import "./purchases.vue?vue&type=style&index=0&id=21a50deb&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a50deb"]])

export default __exports__